.atm_vy_1osqo2v{width:100%;}
.atm_e2_1osqo2v{height:100%;}
.atm_26_1x778eo{background:white;}
.atm_3f_ekfxyd{border:1px solid #8E959E;}
.atm_5j_idpfg4{border-radius:0;}
.atm_7l_qgx6rq{color:#6F7780;}
.atm_9s_1txwivl{display:flex;}
.atm_h_1h6ojuz.atm_h_1h6ojuz{align-items:center;}
.atm_fc_1h6ojuz.atm_fc_1h6ojuz{justify-content:center;}
.atm_c8_1x7uoys.atm_c8_1x7uoys{font-size:0.875rem;}
.atm_uc_lzpjzu{transition:color 250ms ease-out,border-color 250ms ease-out,background 200ms ease-out;}
.atm_1nnvfj6_q74ntv:focus{box-shadow:0 0 0 4px rgba(20,110,245,0.25);}
.atm_4jp0l5_1fw03zg.atm_4jp0l5_1fw03zg:focus{font-weight:700;}
.atm_w8mpmz_glywfm:focus{outline:none;}
.atm_yrb2fr_kb7nvz:focus{z-index:1;}
.atm_1ifcutm_idpfg4:not(:last-of-type){border-right:0;}
.atm_1mc7pf4_1v14isf:first-of-type{border-radius:4px 0 0 4px;}
.atm_1x6p6dx_wptqd7:last-of-type{border-radius:0 4px 4px 0;}
.atm_he062d_nb8q6m[aria-checked='true']{border:2px solid #146EF5;}
.atm_l79561_1aemfod[aria-checked='true']{color:#146EF5;}
.atm_evfbgw_1fw03zg.atm_evfbgw_1fw03zg[aria-checked='true']{font-weight:700;}
.atm_174zlj6_13gfvf7:disabled{cursor:not-allowed;}
.atm_1jhk75u_1piyxwk:disabled{opacity:0.5;}
